<template>
    <div>
        <el-dialog width="768px" title="授权管理" :visible.sync="viewDetail" @close="closeModel">
            <!-- 搜索工具 -->
            <el-row :gutter="10" class="index-head">
                <el-col :span="4">
                    <el-input placeholder="成员名称" v-model="activename" clearable> </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="手机号码" v-model="activephone" clearable> </el-input>
                </el-col>

                <el-col :span="16">
                    <el-button type="primary" @click="handleButton(1)"> 搜 索 </el-button>
                    <el-button type="primary" @click="handleButton(2)">新 增</el-button>
                    <!--  <el-button type="primary"
                     @click="handleButton(3)"> 批量导入
          </el-button> -->
                    <el-button type="text" @click="handleButton(4)"> 下载模板 </el-button>
                </el-col>
            </el-row>
            <!-- table -->
            <div class="table-content scroll-auto">
                <el-table :data="list" border v-loading="listLoading">
                    <el-table-column label="id" prop="act_id"></el-table-column>
                    <el-table-column label="姓名" prop="agent_name"></el-table-column>
                    <el-table-column label="联系方式" prop="agent_phone"></el-table-column>
                    <el-table-column label="录入时间" prop="create_time">
                        <template slot-scope="scope">
                            {{ changeTime(scope.row.create_time) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="激活时间" prop="active_time">
                        <template slot-scope="scope">
                            {{ changeTime(scope.row.active_time) }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="异常处理"
                         prop="end_time"></el-table-column> -->
                </el-table>
            </div>
            <!-- 分页 -->
            <pagination v-if="list.length > 0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />

            <!--   <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 @click="closeModel">确 定</el-button>
    </div> -->
        </el-dialog>
        <div v-if="importdataVible">
            <importdata @closeModel="initModle(1)"></importdata>
        </div>
        <div v-if="addoptVible">
            <addoptcom @closeModel="initModle(2)" :method="getautolist"></addoptcom>
        </div>
    </div>
</template>

<script>
import { formatDate } from "@/options/time";
import addoptcom from "./addnewopt.vue";
import importdata from "./importdata.vue";
import { autolist, exportexcel } from "@/api/erweima/index";
import pagination from "@/components/pagination/index.vue";
export default {
    props: {
        dateils_id: {
            require: true,
        },
    },
    data() {
        return {
            viewDetail: true,
            loading: false,
            activephone: "",
            activename: "",
            list: [],
            pageSize: 5,
            pageNum: 1,
            total: 0,
            listLoading: false,
            importdataVible: false,
            addoptVible: false,
        };
    },
    mounted() {
        this.getautolist();
    },
    methods: {
        changeTime(time) {
            return formatDate(time);
        },
        initModle(num) {
            if (num == 1) {
                this.importdataVible = false;
            } else {
                this.addoptVible = false;
            }
        },
        closeModel() {
            this.$emit("closeModel");
        },
        handleButton(key) {
            switch (key) {
                case 1:
                    this.pageNum = 1;
                    this.getautolist();
                    break;
                case 2:
                    this.addoptVible = true;
                    //this.getautolist()
                    break;
                case 3:
                    this.importdataVible = true;
                    //this.getautolist()
                    break;
                case 4:
                    this.getexportexcel();
                    break;

                default:
                    break;
            }
        },
        pageChange(page) {
            this.pageSize = page._pageSize;
            this.pageNum = page._currentPage;
            this.getautolist();
        },
        //列表
        getautolist() {
            this.list = [];
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                id: this.$getSessionStorage("rebate_id"),
                agent_name: this.activename,
                agent_phone: this.activephone,
                offset: this.pageNum,
                limit: this.pageSize,
            };
            autolist(par)
                .then((res) => {
                    this.listLoading = false;
                    if (res.code == 1) {
                        this.list = res.data.list;
                        this.total = parseInt(res.data.count);
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        //下载
        getexportexcel() {
            exportexcel()
                .then((res) => {
                    if (res.code == 1) {
                        window.location.href = res.data[0];
                    } else {
                        this.$message.error({ message: "下载失败" });
                    }
                })
                .catch((err) => {});
        },
    },
    components: {
        pagination,
        importdata,
        addoptcom,
    },
};
</script>

<style scoped lang="scss">
.index-head{
  margin-bottom: 22px;
}
.table-content{
  height: 350px;
}
</style>
